import { router } from "@/router";
import { Transportadora } from "@/models/transportadora";
import TransportadoraAPI from "../api/transportadora.api";
import { VUE_APP_NAME } from "@/commons/config";
import GlobalStore from "@/store/modules/global";

import TransportadoraStore from "@/store/modules/transportadora";

import { map } from "rxjs/operators";
import { BehaviorSubject, Observable } from "rxjs";
import { AxiosObservable } from "axios-observable/dist/axios-observable.interface";
import JwtDecode from "jwt-decode";

export interface ExpireJwtDecode {
  exp: number;
}

export interface TranportadoraJwtDecode {
  sub: number;
  numeroOrdem: number;
  cnpj: string;
  accessToken: string;
  nomefantasia: string;
  razaoSocial: string;
  exp: number;
}

const AUTH = `${VUE_APP_NAME}-transportadora-auth`;
const transportadoraAPI = new TransportadoraAPI();

const currentTransportadora = () => {
  const { token = null } = JSON.parse(localStorage.getItem(AUTH)) || {};

  if (!token) return null;

  const {
    sub,
    numeroOrdem,
    cnpj,
    accessToken,
    nomefantasia,
    razaoSocial,
    exp,
  } = JwtDecode<TranportadoraJwtDecode>(token);

  verifyExpireToken(exp);

  return new Transportadora(
    sub,
    numeroOrdem,
    cnpj,
    accessToken,
    nomefantasia,
    razaoSocial
  );
};

const verifyExpireToken = function (exp: number) {
  const currentDate = Date.now();
  const expireToken = exp * 1000;

  if (currentDate > expireToken) {
    localStorage.removeItem(AUTH);
    location.reload();
  }
};

const transportadoraSubject = new BehaviorSubject(currentTransportadora());

transportadoraSubject.subscribe((transportadora: Transportadora) => {
  if (TransportadoraStore) {
    TransportadoraStore.setTransportadora(transportadora);
  }
});

const login = (
  cnpj: string,
  token: string,
  recaptcha: string,
  returnUrl?: string
): Observable<Transportadora> => {
  return transportadoraAPI
    .login(cnpj, token, recaptcha)
    .pipe(map((response) => setSession(response, returnUrl)));
};

const logout = (type?: string, message?: string): void => {
  localStorage.removeItem(AUTH);
  transportadoraSubject.next(null);

  GlobalStore.setSnackBar({
    type: type || "success",
    message: message || "Saiu com sucesso!",
    show: true,
    timeout: 4000,
  });

  router.push({ name: "login-transportes" });
};

const setSession = (authResult: any, returnUrl: any): Transportadora => {
  buildAuth(authResult);

  transportadoraSubject.next(currentTransportadora());

  if (returnUrl) {
    router.push({ name: returnUrl });
  } else {
    router.push({ name: "servicos-transportes" });
  }

  GlobalStore.setSnackBar({
    type: "success",
    message: "Login feito com sucesso!",
    show: true,
    timeout: 5000,
  });

  return transportadoraSubject.value;
};

const buildAuth = (transportadora: Transportadora) => {
  localStorage.setItem(AUTH, JSON.stringify(transportadora));
};

const currentToken = () => {
  const { token = null } = JSON.parse(localStorage.getItem(AUTH)) || {};
  return token;
};

const resetarToken = (
  cnpj: string,
  email: string,
  recaptcha: string,
  servico: number
): AxiosObservable<any> => {
  return transportadoraAPI.resetarToken(cnpj, email, recaptcha, servico);
};

const expireToken = (): number => {
  const { token = null } = JSON.parse(localStorage.getItem(AUTH)) || {};

  if (!token) return null;

  const { exp } = JwtDecode<ExpireJwtDecode>(token);
  return exp * 1000;
};

const currentLgpd = () => {
  const { lgpd } = JSON.parse(localStorage.getItem(AUTH)) || {};
  return lgpd;
};

export default {
  login,
  logout,
  resetarToken,
  expireToken,
  get currentTransportadoraValue() {
    return transportadoraSubject.value;
  },
  get token() {
    return currentToken();
  },
  get lgpd() {
    return currentLgpd();
  },
  get auth() {
    return AUTH;
  },
};
